export default {"src":"/_next/static/media/mascot-normal.00f18034.gif","height":200,"width":200,"blurWidth":0,"blurHeight":0};